export default {"src":"/_next/static/media/ic-read-more-gray.21478c5c.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};